
import React from 'react'

import {
  bindTargetMixin,
  CancelButton,
  DateInput,
  SaveButton,
  TextInput
} from '../../../shared/FormBuilder'
import { Paper } from '../../../shared/NarusMaterial'

class Immunization extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  getValues () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props

    this.setState({ isSubmitting: true })
    onSubmit(this.getValues())
  }

  render () {
    const { onCancel } = this.props
    const { isSubmitting } = this.state

    const disableSave = !this.state.value.name

    return (
      <div className='margin-top margin-bottom'>
        <Paper>
          <div className='form-section'>
            <div className='row'>
              <input
                type='hidden'
                name='id'
              />
              <div className='col-xs-12'>
                <TextInput
                  label='Immunization'
                  name='name'
                  required
                />
              </div>
              <div className='col-xs-12 col-sm-6 mui-date-picker-extended'>
                <DateInput
                  label='Date Received'
                  name='date'
                />
              </div>
              <div className='col-xs-12 col-sm-6'>
                <DateInput
                  label='Good Until'
                  name='expirationDate'
                />
              </div>
            </div>
          </div>
          <div className='row end-xs'>
            <div className='col-xs-12'>
              <CancelButton
                noGlobal
                onClick={onCancel}
              />
              <SaveButton
                disabled={isSubmitting || disableSave}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </div>
    )
  }
}

export default Immunization
